var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLessonplanN(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42848 11.6667V20.3333H14.85M13.2856 1.00116C13.1628 1 13.0249 1 12.8674 1H7.11448C5.67436 1 4.95377 1 4.40372 1.29065C3.91988 1.54631 3.52679 1.95396 3.28026 2.45573C3 3.02616 3 3.77345 3 5.26693V20.7336C3 22.2271 3 22.9734 3.28027 23.5438C3.52679 24.0456 3.91988 24.454 4.40372 24.7096C4.95324 25 5.67297 25 7.1103 25L16.8895 25C18.3268 25 19.0455 25 19.595 24.7096C20.0788 24.454 20.4732 24.0456 20.7198 23.5438C20.9997 22.974 20.9997 22.2287 20.9997 20.7381V9.43424C20.9997 9.27061 20.9997 9.12748 20.9985 9M13.2856 1.00116C13.6528 1.00463 13.8851 1.01846 14.1069 1.07368C14.3693 1.139 14.6199 1.24702 14.85 1.39323C15.1094 1.55809 15.3322 1.78909 15.7766 2.25L19.795 6.41731C20.2398 6.87852 20.4609 7.10848 20.6199 7.37759C20.7609 7.61618 20.8652 7.87634 20.9282 8.14844C20.9814 8.37834 20.9951 8.61934 20.9985 9M13.2856 1.00116V4.73333C13.2856 6.22681 13.2856 6.97302 13.5658 7.54345C13.8124 8.04522 14.2055 8.45397 14.6893 8.70963C15.2388 9 15.9585 9 17.3958 9H20.9985M20.9985 9H21",
    stroke: "#0F93A8",
    strokeWidth: 1.88125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonplanN);
export default __webpack_public_path__ + "static/media/lessonplanN.6b814bdcedf5c1b8c4c5cda8ea0c65bb.svg";
export { ForwardRef as ReactComponent };